import { useMemo } from 'react';
import { HexUtils } from '../components/HexGrid';

export function useHexStyles({ hex, gridItemProps, board }) {
  const { tile, layout, boardImageBCR, boardImageOffset } = gridItemProps;
  const pixel = useMemo(() => HexUtils.hexToPixel(hex, layout), [hex, layout]);
  return useMemo(() => {
    if (!gridItemProps.ready) return {};
    const newStyles = {
      width: tile.width,
      height: tile.height,
      backgroundRepeat: 'no-repeat',
      backgroundImage: `url(${board.boardImg})`,
      backgroundSize: `${boardImageBCR.width}px ${boardImageBCR.height}px`,
      backgroundPositionX: `-${pixel.x * tile.scale + boardImageOffset.x}px`,
      backgroundPositionY: `-${pixel.y * tile.scale + boardImageOffset.y}px`,
    };
    return newStyles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [board, tile, pixel.x, pixel.y]);
}
